import * as React from 'react';
import Spinner from './../../assets/images/spinner.png';

const Loader = () => {
    return (
        <div className='loader-container'>
            {/* <img alt="Loading..." className='loader' src={Spinner} /> */}
            <div className='loadermain'>
            <div className="spinner-grow text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <div className="spinner-grow text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <div className="spinner-grow text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <div className="spinner-grow text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <div className="spinner-grow text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            </div>
        </div>
    );
}

export default Loader;